<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'

import { Icon } from '@iconify/vue'

const passwordValue = defineModel<string>({ default: '' })

const inputRef = useTemplateRef<{ focus: () => void }>('inputRef')
const showPassword = ref(false)

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}

const focus = () => {
  if (inputRef.value) {
    inputRef.value.focus()
  }
}

defineExpose({
  focus
})
</script>

<template>
  <el-input
    ref="inputRef"
    v-model="passwordValue"
    v-bind="$attrs"
    :type="showPassword ? 'text' : 'password'"
    class="auth-form-input"
  >
    <template #suffix>
      <button
        type="button"
        class="flex h-full items-center justify-center px-2 text-gray-500 hover:text-gray-700"
        @click="togglePasswordVisibility"
      >
        <Icon
          :icon="showPassword ? 'ri:eye-fill' : 'ri:eye-off-fill'"
          width="20px"
          height="20px"
          class="text-app-black-200"
        />
      </button>
    </template>
  </el-input>
</template>
